import { render, staticRenderFns } from "./TeamModal.vue?vue&type=template&id=3225b3a5&scoped=true&"
import script from "./TeamModal.vue?vue&type=script&lang=js&"
export * from "./TeamModal.vue?vue&type=script&lang=js&"
import style0 from "./TeamModal.vue?vue&type=style&index=0&id=3225b3a5&scoped=true&lang=scss&"
import style1 from "./TeamModal.vue?vue&type=style&index=1&id=3225b3a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3225b3a5",
  null
  
)

export default component.exports